import {
  buildCartMetaParams,
  initMetaPixel,
  trackAddPaymentInfo,
  trackAddToCart,
  trackAppointmentBooked,
  trackCompleteRegistration,
  trackInitiateCheckout,
  trackLead,
  trackLogin,
  trackViewContent,
  type MetaAdvancedMatching,
  type MetaCommerceParams,
} from "./metaPixel";

export {
  buildCartMetaParams,
  initMetaPixel,
  trackAddPaymentInfo,
  trackAddToCart,
  trackAppointmentBooked,
  trackCompleteRegistration,
  trackInitiateCheckout,
  trackLead,
  trackLogin,
  trackViewContent,
};
export type { MetaAdvancedMatching, MetaCommerceParams };

type BriefOrganization = {
  id: number;
  name: string;
  metaPixelId?: string | null;
};

type TrackEventProperties = MetaCommerceParams & {
  Email?: string;
  isResourceSelected?: boolean;
  isLoggedIn?: boolean;
  isVerified?: boolean;
  paymentMethod?: string;
  [key: string]: unknown;
};

/**
 * Bridge existing product analytics names → Meta standard/custom events when a pixel is active.
 * Mixpanel remains stubbed; Meta fires only for conversion-relevant events.
 */
export const trackEvent = (
  eventName: string,
  organization: BriefOrganization,
  properties: TrackEventProperties = {}
) => {
  const commerceParams: MetaCommerceParams = {
    content_ids: properties.content_ids,
    contents: properties.contents,
    content_type: properties.content_type || "product",
    content_name: properties.content_name,
    content_category: properties.content_category,
    value: properties.value,
    currency: properties.currency,
    num_items: properties.num_items,
  };

  switch (eventName) {
    case "Cart Initiated":
    case "Item added to cart":
      trackAddToCart(commerceParams);
      break;
    case "Checkout Initiated":
      trackInitiateCheckout(commerceParams);
      break;
    case "Login":
      trackLogin({ organization_id: organization.id });
      break;
    case "Sign up Completed":
      trackLead({ organization_id: organization.id });
      break;
    case "Verification Completed":
      trackCompleteRegistration({ organization_id: organization.id, status: true });
      break;
    case "Package Selected":
    case "Service Selected":
      trackViewContent(commerceParams);
      break;
    default:
      break;
  }

  return [eventName, organization, properties];
};

export const setUserForTracking = (
  user: ProfileUser | null,
  organization: BriefOrganization | null
) => {
  if (user && organization?.metaPixelId) {
    const matching: MetaAdvancedMatching = {
      em: user.email,
      ph: user.phoneNumber,
      fn: user.firstName,
      ln: user.lastName,
      external_id: user.id,
    };
    void initMetaPixel(organization.metaPixelId, matching);
  }

  return [user, organization];
};
